/* This is a generated file. Do not edit manually. */
import React from 'react';
import PropTypes from 'prop-types';
import iconSizes from '../../iconSizes';

/**
 * BarGraphHorizontalIcon
 */
export default class BarGraphHorizontalIcon extends React.Component {
  static propTypes = {
    /** The size of the icon */
    size: PropTypes.oneOf(['s', 'm', 'l', 'xl']),
    /** The color of the icon */
    color: PropTypes.string.isRequired
  };

  static defaultProps = {
    size: 'm',
    color: 'black'
  };

  render() {
    const { size: sizeProp, color } = this.props;
    const size = correctButtonSize(sizeProp);
    return (
      <svg
        focusable="false"
        xmlns="http://www.w3.org/2000/svg"
        viewBox={'0 0 32 32'}
        style={{ width: iconSizes[size], height: iconSizes[size] }}
      >
        <g style={{ fill: color }}>
          <svg viewBox="0 0 24 24"><path d="M3 2a1 1 0 01.993.883L4 3v17h17a1 1 0 01.117 1.993L21 22H3a1 1 0 01-.993-.883L2 21V3a1 1 0 011-1zm12 14a1 1 0 01.117 1.993L15 18H6a1 1 0 01-.117-1.993L6 16h9zm4-4a1 1 0 01.117 1.993L19 14H6a1 1 0 01-.117-1.993L6 12h13zM6 8h5a1 1 0 01.117 1.993L11 10H6a1 1 0 01-.117-1.993L6 8h5zm9-4a1 1 0 010 2H6a1 1 0 110-2z" fillRule="nonzero"/></svg>
        </g>
      </svg>
    );
  }
}

/* corrects deprecated api, can be removed in future release */
function correctButtonSize(size) {
  switch (size) {
    case 'medium':
      return 'm';
    case 'small':
      return 's';
    case 'large':
      return 'l';
    case 'xlarge':
      return 'xl';
    default:
      return size;
  }
}

